import { render, staticRenderFns } from "./Toggle.vue?vue&type=template&id=53a096b3&"
import script from "./Toggle.vue?vue&type=script&lang=ts&"
export * from "./Toggle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports